import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import FloatingInput from "../common/FloatingInput";
import ServiceModal from "./ServiceModal";
import { censusServices, censusServiceConfigs } from "../services/soar";

const applicationId =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
    : "58990f83-8566-4ba8-b4b5-584a64e4cba1";

const writeAccess = true;
// JSON.parse(
//   localStorage.getItem("safyInfo")
// ).user.modules.includes("Admin");

const availableStatuses = [
  "Occupied",
  "Discharged",
  "Respite",
  "Double Paid Respite",
  "Unpaid Respite",
  "Paid Leave",
  "Unpaid Leave",
];

export function Services(props) {
  const [services, setServices] = useState([]);
  const [search, setSearch] = useState("");
  const [showExpired, setShowExpired] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    const response = await censusServices({
      command: "query",
      application: applicationId,
      keyword: "viewall",
    });
    if (response.code !== "success") {
      toast.info("Error Loading Services");
    } else {
      setServices(response.data.filter((service) => service.active === true));
    }
  };

  const deactivateService = async (serviceId) => {
    const response = await censusServices({
      application: applicationId,
      command: "deactivate",
      id: serviceId,
    });

    if (response.code !== "success") {
      toast.info("Error Deactivating Service");
    } else {
      toast.success("Service Deactivated Successfully");
      loadServices();
    }
  };

  return (
    <>
      <ServiceModal
        isOpen={showModal}
        handleClose={() => setShowModal(false)}
        updateServices={() => loadServices()}
      />
      <div>
        <div className="h4">Service</div>
        <div className="row">
          <div className="col d-inline-block">
            <div className="row">
              <div className="col-10">
                {/* <Input
                  type="text"
                  name="Search"
                  label="Search"
                  placeholder="Search"
                  onChange={(e) => {
                    setSearch(e.currentTarget.value);
                  }}
                  value={search}
                /> */}
              </div>
              <div className="col-2 mt-3 pt-4">
                {/* <i
                  className="fas fa-times-circle fa-xl text-danger"
                  onClick={() => setSearch("")}
                /> */}
              </div>
            </div>
          </div>
          <div className="col mt-3 pt-4 ms-4">
            <div className="row">
              <div className="col">
                {/* <Checkbox
                  name="Active"
                  label="Show Expired"
                  onChange={() => setShowExpired(!showExpired)}
                  checked={showExpired}
                /> */}
              </div>
              <div className="col">
                {writeAccess && (
                  <div
                    className="btn btn-primary float-end"
                    role="button"
                    onClick={() => setShowModal(true)}
                  >
                    Add Service
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row fw-bold mb-2">
          <div className="col">Service</div>
          <div className="col">Type</div>
          <div className="col"></div>
        </div>
        {services
          .filter(
            (si) =>
              si.active === true &&
              si.name.toUpperCase().includes(search.toUpperCase())
          )
          .map((service) => (
            <div
              key={service.id}
              className="row rounded border border-dark bg-light m-1 px-2"
            >
              <div className="col p-1">{service.name}</div>
              <div className="col p-1">{service.type}</div>

              <div className="col m-1">
                <Link title="Open Service" to={`/rev/services/${service.id}`}>
                  <i className="fas fa-eye float-end p-1" role="button"></i>
                </Link>
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export function Service(props) {
  const navigate = useNavigate();
  const { serviceId } = useParams();
  const [service, setService] = useState({});
  const [serviceConfigs, setServiceConfigs] = useState([]);

  useEffect(() => {
    loadService();
  }, []);

  const loadService = async () => {
    const response = await censusServices({
      command: "query",
      application: applicationId,
      keyword: "byid",
      ids: [serviceId],
    });

    if (response.code === "success") {
      setService(response.data[0]);
      loadConfigs();
    } else {
      toast.error("There was an error loading Service", response.message);
    }
  };

  const loadConfigs = async () => {
    const response = await censusServiceConfigs({
      command: "query",
      application: applicationId,
      keyword: "byservice",
      ids: [serviceId],
    });

    if (response.code === "success") {
      setServiceConfigs(
        response.data
          .filter(
            (config) =>
              config.active &&
              (!config.expiration ||
                config.expiration === "" ||
                new Date() < new Date(config.expiration))
          )
          .sort((a, b) => a.name.localeCompare(b.name))
      );
    } else {
      toast.error("Error Loading Service Configurations", response.message);
    }
  };

  const saveService = async () => {
    const response = await censusServices({
      application: applicationId,
      command: "update",
      id: serviceId,
      name: service.name,
      type: service.type,
    });

    if (response.code !== "success") {
      toast.info("Error Updating Service");
    }
  };

  const saveServiceConfig = async (body) => {
    const response = await censusServiceConfigs(body);
    if (response.code === "success") {
      navigate(`/rev/services/${serviceId}/${response.id}`);
    } else {
      toast.error("Error Saving Service Configuration");
    }
  };

  // const handleChange = ({ currentTarget: input }) => {
  //   const value =
  //     input.type === "checkbox" ? input.checked.toString() : input.value;
  //   const obj = { ...serviceItem };
  //   obj[input.name] = value;
  //   setServiceItem(obj);
  // };

  // const handleConfigChange = ({ currentTarget: input }) => {
  //   const value = input.type === "checkbox" ? input.checked : input.value;
  //   const obj = { ...serviceItem.config };
  //   obj[input.name] = value;
  //   setServiceItem({ ...serviceItem, config: obj });
  // };

  // const handleStatusChange = ({ currentTarget: input }) => {
  //   const obj = [...serviceItem.serviceStatuses];
  //   if (input.checked) {
  //     if (!obj.includes(input.name)) obj.push(input.name);
  //   } else {
  //     if (obj.includes(input.name)) {
  //       obj.splice(obj.indexOf(input.name), 1);
  //     }
  //   }
  //   setServiceItem({ ...serviceItem, serviceStatuses: obj });
  // };

  // const repositionStatus = (status, direction) => {
  //   const obj = [...chosenStatuses];
  //   const index = obj.indexOf(status);
  //   if (direction === "up") {
  //     if (index > 0) {
  //       obj.splice(index - 1, 0, obj.splice(index, 1)[0]);
  //     }
  //   } else {
  //     if (index < obj.length - 1) {
  //       obj.splice(index + 1, 0, obj.splice(index, 1)[0]);
  //     }
  //   }
  //   setChosenStatuses(obj);
  // };

  return (
    <>
      <div>
        <div className="h5">Service</div>
        <div className="row rounded bg-safy2-1 py-2">
          <div className="col-4">
            <FloatingInput
              name="name"
              label="Name"
              value={service?.name}
              onChange={(e) => {
                setService({ ...service, name: e.target.value });
                saveService();
              }}
              disabled={!writeAccess}
            />
          </div>
          <div className="col-2">
            <FloatingInput
              type="select"
              name="type"
              label="Type"
              value={service?.type}
              onChange={(e) => {
                setService({ ...service, type: e.target.value });
                saveService();
              }}
              options={[
                { _id: "Census", name: "Census" },
                { _id: "Mental Health", name: "Mental Health" },
              ]}
              disabled={!writeAccess}
            />
          </div>
          <div className="col"></div>
        </div>
        <div className="row">
          <div className="col-10">
            <div className="h5 my-4">Service Configurations</div>
          </div>
          <div className="col-2">
            {writeAccess && (
              <div
                className="btn btn-primary mt-4 float-end"
                role="button"
                onClick={() => {
                  saveServiceConfig({
                    command: "insert",
                    application: applicationId,
                    service: serviceId,
                    name: "",
                    configuration: {},
                    effective: new Date(),
                  });
                }}
              >
                Add Config
              </div>
            )}
          </div>
        </div>
        <div className="row m-2 fw-bold">
          <div className="col">Name</div>
          <div className="col">State</div>
          <div className="col">Effective</div>
          <div className="col">Expiration</div>
          <div className="col"></div>
        </div>
        {serviceConfigs.map((s, sIndex) => (
          <div
            key={`${s.id}-${sIndex}`}
            className="row rounded border border-dark bg-light p-2 m-2"
          >
            <div className="col">{s.name}</div>
            <div className="col">{s.configuration.state}</div>
            <div className="col">{s.effective}</div>
            <div className="col">{s.expiration}</div>
            <div className="col">
              <Link
                title="Open Service"
                to={`/rev/services/${serviceId}/${s.id}`}
              >
                <i className="fas fa-pen float-end p-1" role="button"></i>
              </Link>
            </div>
          </div>
        ))}

        {/* <ExpandDiv title="JSON Config" className="mt-4">
          <div className="h6">
            JSON CONFIG THAT WOULD GET WRITTEN IN DATABASE
          </div>
          {JSON.stringify(serviceItem, undefined, 2)}
        </ExpandDiv>
        <ExpandDiv title="History" className="mt-4">
          Service Item Details History
        </ExpandDiv>
        <ExpandDiv title="Program Units" className="mt-4">
          Program Units that use this Service Item
        </ExpandDiv>
        <ExpandDiv title="Payor Code Rules" className="mt-4">
          Payor Code Rules that use this Service Item
        </ExpandDiv> */}
      </div>
    </>
  );
}
